import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

const ConsentsFilters = ({ filter }) => {
  return (
    <Filters filter={filter} alphabeticalOrder alphabeticalFieldOrder="id">
      <input
        datepickerinput
        label="Data do Consentimento Maior que"
        name="datetimeConsentGteq"
      />
      <input
        datepickerinput
        label="Data do Consentimento Menor que"
        name="datetimeConsentLteq"
      />
      <input textfieldinput="true" label="Nome do Banner" name="bannerName" />
      <input textfieldinput="true" label="URL" name="bannerUrl" />
    </Filters>
  )
}

ConsentsFilters.propTypes = {
  filter: PropTypes.object.isRequired,
}

export default ConsentsFilters
